module.exports = __webpack_public_path__ + "static/img/payewm4.e0fd929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payewm4.png
// module id = Jt4J
// module chunks = 2